var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20687_45651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.208 13.25H3.792C3.35475 13.25 3 12.8953 3 12.458V6.917C3 6.47975 3.35475 6.125 3.792 6.125H5.208C5.64525 6.125 6 6.47975 6 6.917V12.458C6 12.8953 5.64525 13.25 5.208 13.25Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.93112L8.73675 3.36787C9.246 2.70412 10.2405 2.68762 10.7723 3.33337C10.971 3.57412 11.079 3.87712 11.079 4.18912V6.64237H13.401C13.8518 6.64237 14.2725 6.86737 14.523 7.24162L14.7698 7.60987C14.991 7.94062 15.0555 8.35237 14.9453 8.73412L13.926 12.2756C13.7595 12.8539 13.2308 13.2521 12.6293 13.2521H7.9125C7.5375 13.2521 7.179 13.0961 6.924 12.8216L6 11.8271",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20687_45651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
export { SvgThumbsUp as ReactComponent };
export default __webpack_public_path__ + "thumbs_up.svg";